/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'

export type MapSwitchDateProps = {
  today: boolean
  handleSwitch: (today: boolean) => void
}

export const MapSwitchDate = ({ today, handleSwitch }: MapSwitchDateProps) => {
  const todayDate = new Date()
  const tomorrowDate = new Date().setDate(todayDate.getDate() + 1)

  return (
    <div css={rootStyle}>
      <span
        className={`tab ${today ? 'selected' : ''}`}
        onClick={() => handleSwitch(true)}
      >
        <strong>今日</strong>{' '}
        {format(todayDate, 'MM/dd（eee）', {
          locale: ja,
        })}
      </span>
      <span
        className={`tab ${!today ? 'selected' : ''}`}
        onClick={() => handleSwitch(false)}
      >
        <strong>明日</strong>{' '}
        {format(tomorrowDate, 'MM/dd（eee）', {
          locale: ja,
        })}
      </span>
    </div>
  )
}

const rootStyle = css`
  z-index: 1;
  width: 100%;
  max-width: 261px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50px;
  padding: 3px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 4px;
  grid-column-gap: 4px;

  & strong {
    font-size: 14px;
    padding-right: 2px;
  }

  & .tab {
    border-radius: 50px;
    line-height: 16px;
    padding: 6px 0px 5px 6px;
    font-size: 12px;
    text-align: center;
    cursor: pointer;

    &.selected {
      background-color: white;
      color: #3f3d35;
    }
  }
`
